import { Fragment, useCallback, useMemo, useState } from 'react'

import { NewsItem, NewsType } from '~/types/media'

import MediaNewsList from './MediaNewsItem/MediaNewsList'
import MediaNewsNav from './MediaNewsNav/MediaNewsNav'

export default function MediaNews({ items }: { items: NewsItem[] }): React.ReactElement {
  const [selectedType, setSelectedType] = useState(NewsType.ALL)

  const [articles, audios, videos] = useMemo(() => {
    return [
      items.filter((i) => i.type === NewsType.ARTICLE),
      items.filter((i) => i.type === NewsType.AUDIO),
      items.filter((i) => i.type === NewsType.VIDEO),
    ]
  }, [items])

  const filteredItems = useMemo(() => {
    if (selectedType !== NewsType.ALL) {
      return items.filter((i) => i.type === selectedType)
    }
  }, [items, selectedType])

  const Divider = useCallback(() => {
    return <hr className="border-t-4 border-gray-light rounded-full" />
  }, [])

  return (
    <section className="max-w-sm md:max-w-2xl lg:max-w-5xl mx-auto">
      <MediaNewsNav onClick={(type) => setSelectedType(type)} selectedType={selectedType} />

      <Fragment>
        {filteredItems ? (
          <MediaNewsList news={filteredItems} />
        ) : (
          <div className="space-y-12">
            <MediaNewsList news={articles} />
            <Divider />
            <MediaNewsList news={audios} />
            <Divider />
            <MediaNewsList news={videos} />
          </div>
        )}
      </Fragment>
    </section>
  )
}
